import { Link } from 'react-router-dom';
import { getTopTags } from '@/utils/articles';

export default function TagCloud() {
  const tags = getTopTags(15);
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <h3 className="mb-3 flex items-center gap-2 border-b border-background-200 pb-2 text-base font-black text-foreground-950">
        <i className="ri-price-tag-3-fill text-primary-500"></i>
        热门标签云
      </h3>
      <div className="flex flex-wrap gap-2">
        {tags.map(({ tag, count }) => (
          <Link
            key={tag}
            to={`/tags/${encodeURIComponent(tag)}`}
            className="cursor-pointer rounded-full border border-secondary-200 bg-secondary-50 px-3 py-1.5 text-xs text-secondary-900 transition-colors hover:border-primary-300 hover:bg-primary-100 hover:text-primary-700"
          >
            {tag}
            <span className="ml-1 text-[10px] text-foreground-400">{count}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}